const host = window.location.host
const protocol = (window.location.protocol === 'https:' ? 'https://' : 'http://')
let feedbackHost = protocol + 'aiexchange.test.classba.cn'
switch (host) {
  case 'cn-new.classba.cn':
  case 'cn-new.171xue.com':
    feedbackHost = protocol + 'aiexchange.classba.cn'
    break
  default:
    break
}

export { feedbackHost }



// WEBPACK FOOTER //
// ./src/api/index.js